import { Box, styled, Theme, Typography } from '@mui/material';
import { ReleaseSongStatus } from 'services/api/entities/distribution/release';

export const SummaryContainer = styled(Box)({
  display: 'flex',
});

export const MetadataStatusContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
}));

const getStatusColor = (theme: Theme, status: ReleaseSongStatus) => {
  switch (status) {
    case ReleaseSongStatus.VALID:
      return theme.palette.success.light;
    case ReleaseSongStatus.WARNING:
      return theme.palette.warning.light;
    default:
      return theme.palette.error.light;
  }
};

export const MetadataStatusCircle = styled(Box)<{ status: ReleaseSongStatus }>(
  ({ theme, status }) => ({
    borderRadius: '50%',
    width: theme.spacing(1),
    height: theme.spacing(1),
    backgroundColor: getStatusColor(theme, status),
  })
);

export const MetadataStatusLabel = styled(Typography)<{
  status: ReleaseSongStatus;
}>(({ theme, status }) => ({
  fontSize: 12,
  fontWeight: 400,
  lineHeight: theme.spacing(2.5),
  color: getStatusColor(theme, status),
}));
